import "core-js/modules/es6.regexp.split";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ARow from 'ant-design-vue/es/grid/Row';
import ACol from 'ant-design-vue/es/grid/Col';
import { getAction, postAction } from '@/api/manage';
export default {
  name: 'RoleDataruleModal',
  components: {
    ACol: ACol,
    ARow: ARow
  },
  data: function data() {
    return {
      functionId: '',
      roleId: '',
      visible: false,
      tabList: [{
        key: '1',
        tab: '数据规则'
      }, {
        key: '2',
        tab: '按钮权限'
      }],
      activeTabKey: '1',
      url: {
        datarule: "/sys/role/datarule"
      },
      dataruleList: [],
      dataruleChecked: []
    };
  },
  methods: {
    loadData: function loadData() {
      var _this = this;

      getAction("".concat(this.url.datarule, "/").concat(this.functionId, "/").concat(this.roleId)).then(function (res) {
        console.log(res);

        if (res.success) {
          _this.dataruleList = res.result.datarule;
          var drChecked = res.result.drChecked;

          if (drChecked) {
            _this.dataruleChecked = drChecked.split(",");
          }
        }
      });
    },
    saveDataruleForRole: function saveDataruleForRole() {
      var _this2 = this;

      if (!this.dataruleChecked || this.dataruleChecked.length == 0) {
        this.$message.warning("请注意，现未勾选任何数据权限!");
      }

      var params = {
        permissionId: this.functionId,
        roleId: this.roleId,
        dataRuleIds: this.dataruleChecked.join(",")
      };
      console.log("保存数据权限", params);
      postAction(this.url.datarule, params).then(function (res) {
        if (res.success) {
          _this2.$notification.success({
            message: res.message
          });
        } else {
          _this2.$message.error(res.message);
        }
      });
    },
    show: function show(functionId, roleId) {
      this.onReset();
      this.functionId = functionId;
      this.roleId = roleId;
      this.visible = true;
      this.loadData();
    },
    onClose: function onClose() {
      this.visible = false;
      this.onReset();
    },
    onTabChange: function onTabChange(key) {
      this.activeTabKey = key;
    },
    onReset: function onReset() {
      this.functionId = '';
      this.roleId = '';
      this.dataruleList = [];
      this.dataruleChecked = [];
    }
  }
};